// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__8obzx","primary":"Button_primary__toAK6","ghost":"Button_ghost__U3xgq","sm":"Button_sm__rK7mp","disabled":"Button_disabled__8UX6D"};